import BopisViewController from './BopisViewController';

export default BopisViewController;
